import React from 'react';
import { NavToolProps } from './types/NavTool.types';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import './NavTool.scss';
import { trackWithGoogleTagManager } from '../../../../utils/analytics';

const NavTool = ({ link, icoClass }: NavToolProps) => {
  function track() {
    if (icoClass === 'icon-headphone') {
      trackWithGoogleTagManager({
        event: 'event_contactus',
        eventAction: 'open_contactus',
        eventCategory: 'contactus',
        eventLabel: 'general_information',
      });
    }

    if (icoClass === 'icon-piston') {
      trackWithGoogleTagManager({
        event: 'event_find_your_engine',
        eventAction: 'find_your_engine',
        eventCategory: 'find_your_engine',
        eventLabel: 'find_your_engine',
      });
    }
  }

  return (
    <div className="NavTool">
      <span className={`icon ${icoClass} NavTool__Ico ga4-click-ui-navbar`} />
      <span className="NavTool__text">
        <Link className='ga4-click-ui-navbar' field={{ value: link.value }} onClick={track} />
      </span>
    </div>
  );
};

export default NavTool;
